import { Container } from "components/atoms";

import React from "react";
import { useSelector } from "react-redux";

function FooterBase() {
  const currentYear = new Date().getFullYear();
  const { settings } = useSelector((state) => state.settings);

  return (
    <footer className="footer">
      <Container>
        <div className="flex flex-col md:flex-row justify-center md:justify-between items-center gap-3 py-5">
          <div className="flex order-2 md:order-1  gap-2 font-normal text-sm">
            <span className="text-muted-foreground">{currentYear} &copy;</span>
            <a
              href="/"
              className="text-secondary-foreground hover:text-primary"
            >
              {/* BigFoot Mail */}
              {settings?.app_name || "BigFoot Mail"}
            </a>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export const Footer = React.memo(FooterBase);
